<template>
    <div class="">
        <div class="flex justify-between items-center py-2 flex-wrap">
            <div class="flex flex-wrap gap-4 py-2">
                <SearchBar @server-selected="serverSelectedHandeler">
                </SearchBar>

                <div v-if="selectedServerName !== ''" class="w-56 pr-5 text-xs">
                    Usage Status
                    <v-select v-model="selectedSaleStatus" :items="saleStatusList" density="compact" variant="outlined"
                        rounded="0" placeholder="Select Sale Status" style="padding-top: 0px;padding-bottom: 0px;">
                    </v-select>
                </div>
                <div v-if="selectedServerName !== ''" class="w-56 pr-5 text-xs">
                    Proxy Connect Status
                    <v-select v-model="selectedConnStatus" :items="connectStatusList" density="compact" rounded="0"
                        variant="outlined" placeholder="Select Conn Status"
                        style="padding-top: 0px;padding-bottom: 0px;">
                    </v-select>
                </div>
            </div>
            <div v-if="selectedServerName !== ''">
                <v-btn icon="mdi-delete" size="small" style="outline: none;" @click="deleteProxies"
                    class="mr-5 bg-dark text-light"></v-btn>
                <v-btn v-if="selectedServerName !== 'All'" icon="mdi-plus" size="small" style="outline: none;"
                    data-bs-toggle="modal" 
                    :data-bs-target="selectedServerType === 'X_PROXY' ? '#xproxyAddModal' :
                                     selectedServerType === 'PROXYSMART' ? '#proxysmartAddModal' :
                                     selectedServerType === 'IPROXY' ? '#iproxyAddModal' : ''"
                    :disabled="selectedServerType === 'IPROXY' && (iproxyAccessExists || iproxyChecking || iproxyRecovering || !!iproxyCheckError)"
                    class="bg-dark text-light" @click="addProxy"></v-btn>
            </div>
        </div>
        <div v-if="selectedServerType === 'IPROXY'" class="py-2" aria-live="polite">
            <span v-if="iproxyChecking">Checking existing proxy ports...</span>
            <span v-else-if="iproxyCheckError">{{ iproxyCheckError }}</span>
            <span v-else>{{ iproxyReason }}</span>
            <v-btn v-if="iproxyRecoverable" :disabled="iproxyRecovering || iproxyChecking" :loading="iproxyRecovering" @click="recoverProxy" class="ml-2">Recover existing proxy</v-btn>
            <v-btn v-if="iproxyCheckError" :disabled="iproxyChecking || iproxyRecovering" @click="checkIProxy(selectedServerName)" class="ml-2">Retry check</v-btn>
        </div>
        <div v-if="loading === true" class=" flex items-center justify-center absolute custom-style " >
            <img src="../../../assets/loading.gif" class="w-[50px]"/>
        </div>
        <v-btn-toggle v-model="viewType" color="deep-purple-accent-3 " rounded="0" group class="border-b-none border"
            mandatory>
            <v-btn value="table" class="bg-white text-black">
                Table
            </v-btn>
            <v-btn value="graph" class="bg-white text-black ">
                Graph
            </v-btn>
        </v-btn-toggle>
        <TableView ref="tableViewRef" :selectedConnStatus="selectedConnStatus" :selectedServerName="selectedServerName"
            :selectedSaleStatus="selectedSaleStatus" :selectedServerType="selectedServerType"
            v-if="viewType === 'table'" class="border bg-white text-black" />
        <GraphView modem v-if="viewType === 'graph'" class="border bg-white text-black" />
    </div>
    <div>
        <XProxyAddNewOneDialog v-if="selectedServerType === 'X_PROXY'" @close="addNewOneDialogFlag = false" :serverName="selectedServerName" />
        <ProxySmartAddNewOneDialog v-if="selectedServerType === 'PROXYSMART'" @close="addNewOneDialogFlag = false" :serverName="selectedServerName" />
        <IProxyAddNewOneDialog v-if="selectedServerType === 'IPROXY'" @close="addNewOneDialogFlag = false" :serverName="selectedServerName" />
    </div>
</template>
<script setup>
import { ref } from 'vue';
import { useAdminProxyStore, useAlertStore } from "@/stores"
import { storeToRefs } from 'pinia';
import SearchBar from './SearchBar.vue';
import GraphView from "./GraphView.vue";
import TableView from "./TableView.vue";
import XProxyAddNewOneDialog from "./Modals/AddNewOneDialog-XProxy.vue"
import ProxySmartAddNewOneDialog from "./Modals/AddNewOneDialog-ProxySmart.vue"
import IProxyAddNewOneDialog from "./Modals/AddNewOneDialog-IPROXY.vue"

import { watchEffect } from 'vue';
import { watch } from 'vue';
const viewType = ref("table")

const adminProxyStore = useAdminProxyStore()
const { xProxies, smartProxies, loading, serverNames } = storeToRefs(adminProxyStore)
const addNewOneDialogFlag = ref(false)
const selectedServerName = ref("All")
const selectedServerType = ref("X_PROXY")
const iproxyAccessExists = ref(false)
const iproxyChecking = ref(false)
const iproxyRecovering = ref(false)
const iproxyRecoverable = ref(false)
const iproxyReason = ref('')
const iproxyCheckError = ref('')
let checkSequence = 0
const checkIProxy = async (name) => {
    const sequence = ++checkSequence
    iproxyChecking.value = true
    iproxyRecoverable.value = false
    iproxyCheckError.value = ''
    iproxyReason.value = ''
    try {
        const result = await adminProxyStore.hasIProxyAccess(name)
        if (sequence !== checkSequence || selectedServerName.value !== name) return
        iproxyAccessExists.value = !!result.exists
        iproxyRecoverable.value = !!result.recoverable
        iproxyReason.value = result.reason || (result.exists ? 'Existing proxy ports are already linked to this server.' : '')
    } catch (error) {
        if (sequence !== checkSequence || selectedServerName.value !== name) return
        iproxyAccessExists.value = true
        iproxyCheckError.value = String(error?.message || error || 'Unable to check existing ports. Retry.')
    } finally {
        if (sequence === checkSequence) iproxyChecking.value = false
    }
}
const recoverProxy = async () => {
    if (iproxyRecovering.value || !iproxyRecoverable.value) return
    const name = selectedServerName.value
    iproxyRecovering.value = true
    try {
        const result = await adminProxyStore.recoverIProxyAccess(name)
        useAlertStore().success(result.message)
        if (selectedServerName.value === name) {
            await adminProxyStore.loadProxies(name)
            await checkIProxy(name)
        }
    } catch (error) {
        useAlertStore().error(error)
        if (selectedServerName.value === name) await checkIProxy(name)
    } finally {
        iproxyRecovering.value = false
    }
}


const serverSelectedHandeler = (server) => {
    if (!server) return;
    selectedServerName.value = server.name;
    // Prefer the type coming from the SearchBar (so filters like PROXYSMART/IPROXY work),
    // and fall back to the server record's modem_type only if type is missing.
    const record = serverNames.value.find(s => s.name === server.name);
    const resolvedType = server.type || record?.modem_type || 'ALL';
    selectedServerType.value = resolvedType;
    adminProxyStore.loadProxies(server.name);
    if (resolvedType === 'IPROXY') {
        checkIProxy(server.name);
    } else {
        ++checkSequence;
        iproxyChecking.value = false;
        iproxyRecoverable.value = false;
        iproxyCheckError.value = '';
        iproxyReason.value = '';
        iproxyAccessExists.value = false;
    }
}
const addProxy = () => {
    addNewOneDialogFlag.value = true
}
const saleStatusList = ref(['All', 'AVAILABLE', 'USED'])
const connectStatusList = ref(['All', 'CONNECTED', 'DISCONNECTED', 'PAUSED'])
const selectedSaleStatus = ref('All')
const selectedConnStatus = ref('All')

const selectedItems = ref([])

const tableViewRef = ref(null)
const deleteProxies = () => {
    tableViewRef.value.deleteProxies()
}
</script>

<style scoped>
.custom-style {
    width: -webkit-fill-available; /* Safari/WebKit */
    height: -webkit-fill-available; /* Safari/WebKit */
    width: -moz-available; /* Firefox */
    height: -moz-available; /* Firefox */
    width: fill-available; /* Standard syntax, for future compatibility */
    height: fill-available; /* Standard syntax, for future compatibility */
}
</style>